import { render, staticRenderFns } from "./OlympiadNotificationBanner.vue?vue&type=template&id=3d8e4c44&scoped=true&lang=pug&"
import script from "./OlympiadNotificationBanner.vue?vue&type=script&lang=js&"
export * from "./OlympiadNotificationBanner.vue?vue&type=script&lang=js&"
import style0 from "./OlympiadNotificationBanner.vue?vue&type=style&index=0&id=3d8e4c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e4c44",
  null
  
)

export default component.exports